/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { VaultProviderAttributesInput } from '../models/VaultProviderAttributesInput';

export class CreateVaultRequest {
  /**
  * The account uuid associated with the backup vault
  */
  'vaultAccountId'?: string;
  /**
  * The name of the backup vault
  */
  'name': string;
  /**
  * The region where the backup vault is located
  */
  'region': string;
  'vaultAttributes': VaultProviderAttributesInput;
  /**
  * The tags associated with the backup vault
  */
  'resourceTags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultAccountId",
      "baseName": "vaultAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultAttributes",
      "baseName": "vaultAttributes",
      "type": "VaultProviderAttributesInput",
      "format": ""
    },
    {
      "name": "resourceTags",
      "baseName": "resourceTags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateVaultRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

